import * as React from "react";
import Lottie from "lottie-react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import "./modal.scss";

export default function ModalPopUp({ isOpen, handleModalClose, message, icon, className }) {
  return (
    <React.Fragment>
      <Dialog open={isOpen}>
        <div className={`modal-section ${className}`}>
          {icon && 
            <div className="status-icon">
              <Lottie loop={true} animationData={icon} />
            </div>
          }
          <div className="modal-title">{message.title}</div>
          <div className="modal-text">{message.text}</div>
          <Button onClick={handleModalClose} className="modal-btn">
            OK
          </Button>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export function TwoBtnModal({ isOpen, handleOk, handleCancel, message, icon, className, showCancelButton }){
  return (
    <React.Fragment>
      <Dialog open={isOpen} onClose={handleCancel}>
        <div className="twoBtnModal">
          {icon &&
            <div className="status-icon">
              <Lottie loop={true} animationData={icon} />
            </div>
          }

          <div className="modal-title">{message.title}</div>
          <div className="modal-text">{message.text}</div>
          
          <div className="twoBtnModal-Btns">
            <Button onClick={handleOk} className="modal-btn">
              Yes
            </Button>
            {showCancelButton && (
              <Button onClick={handleCancel} className="modal-btn">
                No
              </Button>
            )}
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
